const errorCodes = {
  '1': 'Wrong email address or password',
  '2':
    'Your account has been temporarily disabled. Please wait a while before you try to log in again.',
  '403': `You don't have permission to log into this part of Accedo One.`,
};

export const getErrorMessageByCode = code => {
  switch (code) {
    case '403':
    case '2':
    case '1':
      return errorCodes[code];
    default:
      return 'Something went wrong';
  }
};



// WEBPACK FOOTER //
// ./src/client/src/errors.js